import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
  Jumbotron,
  Container
} from "reactstrap";

class Home extends Component {
  render() {
    return (
      <Container className="mt-4">
        <Jumbotron className="p-4">
          <h1 className="display-3">UTAD Requests</h1>
          <p className="lead">
            Submit a request for photo, video or other creative resources from
            the University of Tennessee athletic department
          </p>
          <img
            style={{ width: "100%" }}
            src="/graphics/vol-camera.jpg"
            alt="A photographer wearing a Tennessee hat"
          />
          <ListGroup>
            <Link to="/photo">
              <ListGroupItem>
                <ListGroupItemHeading>Photo Requests</ListGroupItemHeading>
                <ListGroupItemText>
                  Submit an assignment or event you need covered, request images
                  from our archives, request images for news coverage
                </ListGroupItemText>
              </ListGroupItem>
            </Link>
            <Link to="/video">
              <ListGroupItem>
                <ListGroupItemHeading>Video Requests</ListGroupItemHeading>
                <ListGroupItemText>
                  Submit an assignment or event you need covered, request videos
                  from our archives, request videos for news coverage
                </ListGroupItemText>
              </ListGroupItem>
            </Link>
            <Link to="/spirit">
              <ListGroupItem>
                <ListGroupItemHeading>
                  Spirit Team Appearance Requests
                </ListGroupItemHeading>
                <ListGroupItemText>
                  Request an appearance at an event by members of the Tennessee
                  Spirit Team, including mascots and members of the cheer and
                  dance teams
                </ListGroupItemText>
              </ListGroupItem>
            </Link>
            {/* <Link to="/facilities">
              <ListGroupItem>
                <ListGroupItemHeading>
                  Facility Project Requests
                </ListGroupItemHeading>
                <ListGroupItemText>
                  Submit a facilities project request, including repairs, new
                  builds, graphics, maintenance requests, etc.
                </ListGroupItemText>
              </ListGroupItem>
            </Link> */}
            {/* <ListGroupItem>
              <ListGroupItemHeading>
                Video Requests (COMING SOON)
              </ListGroupItemHeading>
              <ListGroupItemText>
                  Submit event coverage needs, ask for historical footage, broadcast needs and more
                </ListGroupItemText>
            </ListGroupItem> */}
          </ListGroup>
        </Jumbotron>
      </Container>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home/Home.js